import React from "react";
import "react-universal-hooks";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import "bootstrap/dist/css/bootstrap.min.css";
import Auth0ProviderWithHistory from "./auth/Auth0ProviderWithHIstory";
import { AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";
import ErrorPage from "pages/core/error/ErrorPage";
import { reactPlugin } from "utilities/AppInsights";
import store from "redux/store/store";

ReactDOM.render(
  <AppInsightsErrorBoundary onError={ErrorPage} appInsights={reactPlugin}>
    <React.StrictMode>
      <BrowserRouter>
        <Auth0ProviderWithHistory>
          <Provider store={store}>
            <App />
          </Provider>
        </Auth0ProviderWithHistory>
      </BrowserRouter>
    </React.StrictMode>
  </AppInsightsErrorBoundary>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
